import { render, staticRenderFns } from "./WhereClockIcon.vue?vue&type=template&id=96245cbe"
import script from "./WhereClockIcon.vue?vue&type=script&lang=js"
export * from "./WhereClockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports